import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/departments",
      name: "departments",
      component: () => import("./views/AdminDepartments.vue"),
      meta: {
        requiresAuth: true,
        adminOnly: true
      }
    },
    {
      path: "/categories",
      name: "categories",
      component: () => import("./views/AdminCategories.vue"),
      meta: {
        requiresAuth: true,
        adminOnly: true
      }
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./views/AdminUsers.vue"),
      meta: {
        requiresAuth: true,
        adminOnly: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "*",
      name: "all",
      component: () => import("./views/Home.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // const currentUser = auth().currentUser;
  const currentUser = store.state.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const adminOnly = to.matched.some(record => record.meta.adminOnly);
  const isAdmin = currentUser ? currentUser.isAdmin : false;

  if (!currentUser && requiresAuth) next("login");
  else if (!isAdmin && adminOnly) next("home");
  // else if (!requiresAuth && currentUser) next("home");
  else next();
});

export default router;
